import { masterGetMasterAsyncAction } from './masterActions';
import { createEpic } from '../helpers';

export const masterGetEpic = createEpic(
	masterGetMasterAsyncAction,
	'master',
	'getMaster',
	true
);
